import React from "react";
import { TableModule } from "../../../components/home/TableModule";
import { useTramitTurns } from "../../../hooks/turns/useTramitTurns";
import { HeaderModule } from "../../../components/home/HeaderModule";

export const TramitTurns = ({ sede }) => {

    const { columns, total, turnos } = useTramitTurns(sede);

    return (
        <>
            <HeaderModule
                icon={ <></> }
                title='En trámite'
                component={ (
                    <div style={{ padding: '2px 5px', borderRadius: 6, background: '#00365F', display: 'flex', justifyContent: 'center', minWidth: 30, maxWidth: 50 }}>
                        <h3 style={{ color: '#fff' }}>{ total }</h3>
                    </div>
                ) }
            />

            <TableModule 
                columns={ columns }
                rows={ turnos }
                styles={{
                    height: '40dvh',
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10
                }}
            />
        </>
    );
}